const BoxesIcon = () => (
  <svg
    width="111"
    height="99"
    viewBox="0 0 111 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84.5 11.865L55.625 0L26.75 11.8702V41.559L0.5 52.3425V86.1682L29.375 98.028L55.625 87.2445L81.875 98.028L110.75 86.163V52.3425L84.5 41.559V11.865ZM81.875 61.5405L63.857 54.1695L82.631 46.4625L100.649 53.865L81.875 61.5405ZM53 25.6672V50.1795L32 41.5537V17.0835L53 25.6672ZM58.25 50.1795V25.6672L79.25 17.0835V41.5537L58.25 50.1795ZM47.393 54.1695L29.375 61.5405L10.601 53.8597L28.619 46.4572L47.393 54.1695ZM32 66.1395L53 57.5505V82.6455L32 91.266V66.1395ZM74.399 13.3927L55.625 21.063L36.851 13.398L55.625 5.6805L74.399 13.3927ZM5.75 57.5505L26.75 66.1395V91.266L5.75 82.6455V57.5505ZM58.25 57.5505L79.25 66.1395V91.266L58.25 82.6455V57.5505ZM84.5 91.266V66.1395L105.5 57.5505V82.6455L84.5 91.266Z"
      fill="currentColor"
    />
  </svg>
)
export default BoxesIcon
